import { render, staticRenderFns } from "./CollapseContainer.vue?vue&type=template&id=4075343f"
import script from "./CollapseContainer.vue?vue&type=script&lang=js"
export * from "./CollapseContainer.vue?vue&type=script&lang=js"
import style0 from "./CollapseContainer.vue?vue&type=style&index=0&id=4075343f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports